<!-- PROGRESS BAR -->
<fuse-progress-bar></fuse-progress-bar>
<!-- / PROGRESS BAR -->

<ng-container>
    <vertical-layout-1></vertical-layout-1>
</ng-container>
